import React, { Fragment } from 'react';
import { CheckDiffText } from './common/utils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import AltNames from '../Port/AltNames';

const Sidebar = ({ port, newPort, onEditAltNames }) => (
    <Fragment>
        <div className='col-lg-3 col-xs-3 sidebar'>
            <div className='name'>
                <CheckDiffText
                    oldValue={port.name}
                    newValue={newPort.name}
                />
            </div>

            <div className='name country'>
                <CheckDiffText
                    oldValue={newPort.country ? newPort.country.name : newPort.country}
                    newValue={newPort.country ? newPort.country.name : newPort.country}
                />
            </div>

            <div className='divider' />

            <div className='info'>
                <div className='info__title'>
                    <span className='gray'>UN LOCODE: </span>
                    <CheckDiffText
                        oldValue={port.unLoCode}
                        newValue={newPort.unLoCode}
                    />
                </div>

                <div className='info__title'>
                    <span className='gray'>Time Zone: </span>
                    <CheckDiffText
                        oldValue={port.timezone}
                        newValue={newPort.timezone}
                    />
                </div>

                <a href={port.site} className='info__website'>
                    <CheckDiffText
                        oldValue={port.site}
                        newValue={newPort.site}
                    />
                </a>
                <AltNames
                    port={port}
                    onEditAltNames={onEditAltNames}
                    isForApproval
                />
            </div>
        </div>
    </Fragment>
);

Sidebar.propTypes = {
    port: PropTypes.object.isRequired,
    newPort: PropTypes.object.isRequired,
    onEditAltNames: PropTypes.func,
};

Sidebar.defaultProps = {
    onEditAltNames: () => {},
};

export default connect(
    (state, { port, newPort }) => ({
        port,
        newPort,
    }),
    dispatch => bindActionCreators({
    }, dispatch),
)(Sidebar);



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/Sidebar.jsx